var map = {
	"./Base": 201,
	"./Base/": 201,
	"./Base/config": 846,
	"./Base/config.js": 846,
	"./Base/index": 201,
	"./Base/index.js": 201,
	"./Base/style": 173,
	"./Base/style.js": 173,
	"./Clutch": 494,
	"./Clutch/": 494,
	"./Clutch/index": 494,
	"./Clutch/index.js": 494,
	"./Clutch/style": 1138,
	"./Clutch/style.js": 1138,
	"./NewUi": 495,
	"./NewUi/": 495,
	"./NewUi/index": 495,
	"./NewUi/index.js": 495,
	"./NewUi/style": 1139,
	"./NewUi/style.js": 1139,
	"./OldUi": 496,
	"./OldUi/": 496,
	"./OldUi/index": 496,
	"./OldUi/index.js": 496,
	"./OldUi/style": 1140,
	"./OldUi/style.js": 1140,
	"./SpireonNew": 497,
	"./SpireonNew/": 497,
	"./SpireonNew/index": 497,
	"./SpireonNew/index.js": 497,
	"./SpireonNew/style": 1141,
	"./SpireonNew/style.js": 1141,
	"./SpireonOld": 498,
	"./SpireonOld/": 498,
	"./SpireonOld/index": 498,
	"./SpireonOld/index.js": 498,
	"./SpireonOld/style": 1142,
	"./SpireonOld/style.js": 1142
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1972;
module.exports = webpackAsyncContext;